import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote, Star, ExternalLink } from "lucide-react";
import { TESTIMONIALS, REVIEW_META } from "../mock";

const Testimonials = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % TESTIMONIALS.length), 8000);
    return () => clearInterval(t);
  }, []);

  const cur = TESTIMONIALS[i];

  return (
    <section id="reviews" className="py-28 md:py-36 bg-[#1f1d1a] text-[#f5efe6] relative">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <p className="kicker text-[#c9a87c] mb-6 reveal">Real couples. Real reviews.</p>

        <div className="flex items-center justify-center gap-2 mb-8 reveal">
          {[0,1,2,3,4].map((s) => (
            <Star key={s} size={18} className="text-[#c9a87c]" fill="#c9a87c" />
          ))}
          <span className="ml-3 text-sm text-[#e8dfc9]/80">
            {REVIEW_META.rating} from {REVIEW_META.count} verified reviews
          </span>
        </div>

        <Quote size={42} className="text-[#c9a87c] mx-auto mb-10 reveal" strokeWidth={1} />

        <div className="min-h-[260px] md:min-h-[240px] flex flex-col items-center justify-center">
          <blockquote key={i} className="font-display italic display-tight text-2xl md:text-4xl lg:text-5xl leading-[1.2] text-[#f5efe6] max-w-4xl">
            “{cur.quote}”
          </blockquote>
          <div className="mt-10">
            <p className="font-display text-xl text-[#c9a87c]">{cur.couple}</p>
            <p className="text-[0.7rem] tracking-[0.3em] uppercase text-[#e8dfc9]/70 mt-2">{cur.date}</p>
            <a
              href={cur.sourceUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-[0.7rem] tracking-[0.2em] uppercase text-[#e8dfc9]/60 hover:text-[#c9a87c] transition-colors"
            >
              {cur.source} <ExternalLink size={11} />
            </a>
          </div>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          <button
            onClick={() => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
            className="p-3 border border-[#3a342c] hover:border-[#c9a87c] transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={18} className="text-[#e8dfc9]" />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className={`h-1 transition-all duration-500 ${idx === i ? "w-10 bg-[#c9a87c]" : "w-5 bg-[#3a342c]"}`}
                aria-label={`Go to ${idx + 1}`}
              />
            ))}
          </div>
          <button
            onClick={() => setI((p) => (p + 1) % TESTIMONIALS.length)}
            className="p-3 border border-[#3a342c] hover:border-[#c9a87c] transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={18} className="text-[#e8dfc9]" />
          </button>
        </div>

        <a
          href={REVIEW_META.reviewsUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 mt-12 text-[0.72rem] tracking-[0.3em] uppercase text-[#c9a87c] hover:text-[#f5efe6] transition-colors reveal"
        >
          Read all {REVIEW_META.count} reviews <ExternalLink size={12} />
        </a>
      </div>
    </section>
  );
};

export default Testimonials;
